export default "__VITE_ASSET__DUfvXmla__"